import { NavLink, Link } from "react-router-dom";
import SVG from '../utility/Svg';
import React, {useState, useEffect} from 'react';

function HandleActiveNav(props) {
  return (
    <NavLink className={({ isActive, isPending }) => isPending ? props.classes + " pending" : isActive ? props.classes + " active" : props.classes } to={props.url}>{props.path}</NavLink>
  )
}

function Nav() {

  return (  
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <SVG 
            width='300px'
            fill='none'
            stroke='#D49E0E'
            ></SVG>
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Teaching Philosophy
              </a>
              <ul className="dropdown-menu">
                <li><HandleActiveNav classes="dropdown-item" url='/fundamentals' path='Fundamentals' /></li>
                <li><HandleActiveNav classes="dropdown-item" url='/theory' path='Music Theory' /></li>
                <li><HandleActiveNav classes="dropdown-item" url='/more' path='More than just scales' /></li>
                <li><HandleActiveNav classes="dropdown-item" url='/dream' path='Play the way you Dream of' /></li>
                <li><HandleActiveNav classes="dropdown-item" url='/levels' path='Beginner to Advanced...' /></li>
              </ul>
            </li>
            <li className="nav-item">
              <HandleActiveNav classes="nav-link" url='/Booking' path='Book a Lesson' />
            </li>
            <li className="nav-item">
              <HandleActiveNav classes="nav-link" url='/Recommendations' path='Recommendations' />
            </li>
            <li className="nav-item">
              <HandleActiveNav classes="nav-link" url='/About' path='About' />
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                 Student Portal
              </a>
              <ul className="dropdown-menu">
                <li><HandleActiveNav classes="dropdown-item" url='/Portal' path='Dashboard' /></li>
                <li><HandleActiveNav classes="dropdown-item" url='/Lessons' path='Lesson Materials' /></li>
                <li><HandleActiveNav classes="dropdown-item" url='/Nigel' path='Nigel, the Guitar Guru' /></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
